'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../../styles/sections/template-contact.scss');

require('../sections/template-page-contact');

(0, _themeSections.load)(['template-page-contact']);